import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import { CustomizedButton } from "../../components/Buttons/CustomizedButton";
import VoteTable from "../../components/VoteTable";
import { dappData, DappDataType } from "../../utils/data";
import { conciseAddress } from "../../utils/formatter";
import DescriptionText from "./DescriptionText";

const DappDetailPage: FC = () => {
  let { id } = useParams();
  const findDapp = dappData.find((data) => id == String(data.id));
  let DappData: DappDataType = {
    id: 1,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo: "https://user-images.githubusercontent.com/35243/140804979-0ef11e0d-d527-43c1-93cb-0f48d1aec542.png",
    dappName: "Open Sea",
    description:
      "Building an open digital economy At OpenSea, we're excited about a brand new type of digital good called a non-fungible token, or NFT. NFTs have exciting new properties: they’re unique, provably scarce, tradeable, and usable across multiple applications. Just like physical goods, you can do whatever you want with them! You could throw them in the trash, gift them to a friend across the world, or go sell them on an open marketplace. But unlike physical goods, they're armed with all the programmability of digital goods. A core part of our vision is that open protocols like Ethereum and interoperable standards like ERC-721 and ERC-1155 will enable vibrant new economies. We're building tools that allow consumers to trade their items freely, creators to launch new digital works, and developers to build rich, integrated marketplaces for their digital items. We’re proud to be the first and largest marketplace for NFTs.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 5,
    RegisterAt: "18/Nov/2022",
    url: "https://decentradsplatform.web.app/",
    following: 100,
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 3,
      },
    ],
  };
  if (findDapp) {
    DappData = findDapp;
  }
  return (
    <section className="dark:bg-green-900">
      <div className="container px-6 py-10 mx-auto">
        <div className="lg:flex lg:-mx-6">
          <div className="lg:w-3/4 lg:px-6">
            {/* <div className="flex justify-center">
              <img
                className="object-cover object-center place-content-center  h-80 xl:h-[28rem] rounded-xl"
                src="https://images.unsplash.com/photo-1624996379697-f01d168b1a52?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
              />
            </div> */}
            <div>
              {/* <p className="mt-6 text-sm text-blue-500 uppercase">
                Want to know
              </p> */}
              <h1 className="max-w-lg mt-4 text-4xl font-semibold leading-tight text-gray-800 dark:text-white">
                {DappData.dappName}
              </h1>
              <div className="flex items-center mt-6">
                <img
                  className="object-cover object-center w-10 h-10 rounded-full"
                  src={DappData.logo}
                />
                <div className="mx-4">
                  <h1 className="text-sm text-gray-700 dark:text-gray-200">
                    {DappData.address}
                  </h1>
                  <a
                    href={DappData.url}
                    target="_blank"
                    className="text-sm text-gray-500 dark:text-gray-400"
                  >
                    {DappData.url}
                  </a>
                </div>
              </div>
              <DescriptionText text={DappData.description} />
            </div>
            <div className="py-10">
              <h2 className="text-2xl py-2 font-bold">Voters</h2>
              <VoteTable voterData={DappData.voters} />
            </div>
          </div>
          <div className="mt-8 lg:w-1/4 lg:mt-0 lg:px-6">
            {/* <div>
              <h3 className="text-blue-500 capitalize">Design instument</h3>
              <a
                href="#"
                className="block mt-2 font-medium text-gray-700 hover:underline hover:text-gray-500 dark:text-gray-400 "
              >
                How to raise $100k+ by using blox ui kit on your design
              </a>
            </div>
            <hr className="my-6 border-gray-200 dark:border-gray-700" />
            <div>
              <h3 className="text-blue-500 capitalize">UI Resource</h3>
              <a
                href="#"
                className="block mt-2 font-medium text-gray-700 hover:underline hover:text-gray-500 dark:text-gray-400 "
              >
                Should you creat UI Product by using Blox?
              </a>
            </div>
            <hr className="my-6 border-gray-200 dark:border-gray-700" />
            <div>
              <h3 className="text-blue-500 capitalize">Premium Collection</h3>
              <a
                href="#"
                className="block mt-2 font-medium text-gray-700 hover:underline hover:text-gray-500 dark:text-gray-400 "
              >
                Top 10 Blocks you can get on Blox's collection.
              </a>
            </div>
            <hr className="my-6 border-gray-200 dark:border-gray-700" />
            <div>
              <h3 className="text-blue-500 capitalize">Premium kits</h3>
              <a
                href="#"
                className="block mt-2 font-medium text-gray-700 hover:underline hover:text-gray-500 dark:text-gray-400 "
              >
                Top 10 Ui kit you can get on Blox's collection.
              </a>
            </div> */}
            <div className="w-full sticky top-20">
              <div
                className="
         bg-white
         rounded-xl
         relative
         z-10
         overflow-hidden
         border border-primary border-opacity-20
         shadow-pricing
         py-10
         px-8
         sm:p-12
         lg:py-10 lg:px-6
         xl:p-12
         mb-10
         "
              >
                <span className="text-primary text-xl prose-gray font-bold block mb-4">
                  Information
                </span>

                <div className="mb-7">
                  <span className="text-xl prose-gray font-semibold">
                    App Category:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {DappData.AppCategory}
                  </p>
                  <span className="text-xl prose-gray font-semibold">
                    Ad deals:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {DappData.AdDeals}
                  </p>

                  <span className="text-xl prose-gray font-semibold">
                    Register at:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    {DappData.RegisterAt}
                  </p>

                  <span className="text-xl prose-gray font-semibold">
                    Dapp Contract Address:
                  </span>
                  <p className="text-base text-body-color leading-loose mb-1">
                    <a
                      href={
                        "https://testnet.aurorascan.dev/address/" +
                        DappData.address
                      }
                      target="_blank"
                    >
                      {conciseAddress(DappData.address)}
                    </a>
                  </p>
                </div>
                <Link to="/create-ad-proposal">
                  <CustomizedButton text="Propose Ad" />
                </Link>
                <div>
                  <span className="absolute right-4 top-4 z-[-1]"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DappDetailPage;
